import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const RestoreTicketValidationSchema = z.object({
  spaceId: z.string({ message: 'Space ID is required' }).min(1),
  ticketId: z.string({ message: 'Ticket ID is required' }).min(1),
});
export type TRestoreTicketValidation = z.infer<typeof RestoreTicketValidationSchema>;
export type TRestoreTicketPayload = TRestoreTicketValidation;
export type TRestoreTicketResponse = ApiResponse<{
  message: string;
}>;

export const restoreTicket = async (payload: TRestoreTicketPayload): Promise<TRestoreTicketResponse> => {
  const url = `/ticket/restore-ticket/${payload.ticketId}`;

  return axiosInstance.patch(url);
};

/**
 * Use Restore Ticket React-Query Hook
 */
type UseRestoreTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof restoreTicket, AxiosErrorCustom>;
};

/**
 * Use Restore Ticket React-Query Hook
 */
export const useRestoreTicketMutation = ({ mutationConfig }: UseRestoreTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: restoreTicket,
    ...restConfig,
  });
};
